module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/kultura.jpg?0861d149";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/kultura.jpg
// module id = 2429
// module chunks = 0